import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

declare let dataLayer: any;

declare let gtag: Function;
@Injectable({
    providedIn: "root"
})
export class GoogleAnalyticsService {
    private trackingID: string;

    constructor(public router: Router) {}

    public eventEmitter(
        eventName: string,
        eventCategory: string,
        eventAction: string,
        eventLabel: string = null,
        eventValue: number = null
    ): void {
        gtag("event", eventName, {
            eventCategory: eventCategory,
            eventLabel: eventLabel,
            eventAction: eventAction,
            eventValue: eventValue
        });
        console.log(`send event ${eventName} to GoogleAnalytics`);
    }

    load(): void {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                gtag("config", this.trackingID, {
                    page_path: event.urlAfterRedirects
                });
            }
        });
    }

    onload(): void {
        gtag("js", new Date());
        gtag("config", this.trackingID);

        // this.router.events.subscribe((event) => {
        //     if (event instanceof NavigationEnd) {
        //         gtag("event", "page_view", {
        //             page_title: document.title,
        //             page_location: event.urlAfterRedirects,
        //             page_path: event.urlAfterRedirects,
        //             send_to: this.trackingID
        //         });
        //     }
        // });
    }

    gtag(...args: any[]) {
        dataLayer.push(args);
    }

    AddPaymentInfo(
        value: number,
        payment_type: string,
        item_id: string,
        item_name: string,
        item_category: string,
        userEmail: string,
        coupon?: string
    ): void {
        gtag("event", "add_payment_info", {
            eventCategory: "ecommerce",
            currency: "BRL",
            value: value,
            coupon: coupon,
            payment_type: payment_type,
            userEmail: userEmail,
            items: {
                item_id: item_id,
                item_name: item_name,
                item_category: item_category
            }
        });
    }

    BeginCheckout(value: number, item_id: string, item_name: string, item_category: string, coupon?: string): void {
        gtag("event", "begin_checkout", {
            eventCategory: "ecommerce",
            currency: "BRL",
            value: value,
            coupon: coupon,
            items: {
                item_id: item_id,
                item_name: item_name,
                item_category: item_category
            }
        });
    }

    CheckoutProgress(value: number, item_id: string, item_name: string, item_category: string, coupon?: string): void {
        gtag("event", "checkout_progress", {
            eventCategory: "ecommerce",
            currency: "BRL",
            value: value,
            coupon: coupon,
            items: {
                item_id: item_id,
                item_name: item_name,
                item_category: item_category
            }
        });
    }

    Login(email: string, usernames: string[], name: string, method?: string): void {
        gtag("event", "login", {
            eventCategory: "engagement",
            method: method,
            email: email,
            username: usernames,
            name: name
        });
    }

    Purchase(
        transactionId: string,
        value: number,
        item_id: string,
        item_name: string,
        item_category: string,
        userEmail: string,
        coupon?: string
    ): void {
        gtag("event", "purchase", {
            eventCategory: "ecommerce",
            currency: "BRL",
            transaction_id: transactionId,
            value: value,
            coupon: coupon,
            userEmail: userEmail,
            items: {
                item_id: item_id,
                item_name: item_name,
                item_category: item_category
            }
        });
    }

    Search(content_category: string, search: string, userEmail?: string): void {
        gtag("event", "search", {
            eventCategory: "engagement",
            search_term: search,
            content_category: content_category,
            userEmail: userEmail
        });
        console.log("sent event search to gtag");
    }

    SelectContent(category: string): void {
        gtag("event", "select_content", {
            eventCategory: "engagement",
            content_type: category
        });
    }

    sign_up(email: string, username: string, name: string, method?: string): void {
        gtag("event", "sign_up", {
            eventCategory: "engagement",
            method: method,
            email: email,
            username: username,
            name: name
        });
    }

    ViewItem(
        value: number,
        item_id: string,
        item_name: string,
        item_category: string,
        contentCategory: string,
        userEmail: string
    ): void {
        gtag("event", "view_item", {
            eventCategory: "engagement",
            contentCategory: contentCategory,
            currency: "BRL",
            value: value,
            userEmail: userEmail,
            items: {
                item_id: item_id,
                item_name: item_name,
                item_category: item_category
            }
        });
    }

    ViewCourseContent(
        courseName: string,
        courseId: string,
        courseCategory: string,
        currentLesson: string,
        userEmail: string
    ): void {
        gtag("event", "view_course_content", {
            eventCategory: "engagement",
            courseName: courseName,
            courseId: courseId,
            courseCategory: courseCategory,
            currentLesson: currentLesson,
            userEmail: userEmail
        });
    }

    ViewItemList(item_list_name: string, item_list_id?: string): void {
        gtag("event", "view_item_list", {
            eventCategory: "engagement",
            item_list_id: item_list_id,
            item_list_name: item_list_name
        });
    }

    ViewPromotion(item_name: string, item_category: string, item_id: string): void {
        gtag("event", "view_promotion", {
            eventCategory: "engagement",
            items: {
                item_id: item_id,
                item_name: item_name,
                item_category: item_category
            }
        });
    }

    freeCourseRegistration(courseName: string, courseId: string, email: string, userName: string): void {
        gtag("event", "free_course_registration", {
            eventCategory: "engagement",
            courseName: courseName,
            courseId: courseId,
            email: email,
            userName: userName
        });
    }

    CompleteRegistration(status: boolean, content_name: string, name: string, userEmail: string): void {
        gtag("event", "complete_registration", {
            registrationBy: content_name,
            status: status,
            name: name,
            email: userEmail
        });
    }
}
